document.addEventListener('DOMContentLoaded', () => {
  // Video Testimonial slider behavior is handled by the `simple-slider` web component.
  // This file is intentionally a no-op to avoid double-binding dots/scroll behavior.
});